<template>
    <div class="pa-5 pt-0 pb-3">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Amount sum" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ sum ? sum : "-" }}
            </v-col>
        </v-row>
        <v-row v-if="activeExportInvoice.odoo_link">
            <v-col class="col-item" cols="9">
                <a :href="activeExportInvoice.odoo_link" target="_blank">{{ activeExportInvoice.odoo_link }}</a>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "stickers-sum-view",
    data() {
        return {
            sum: null
        };
    },
    mounted() {},
    watch: {
        activeExportInvoice: function() {
            this.sum = 0;
            if (!this.activeExportInvoice || !this.activeExportInvoice.rows || !this.activeExportInvoice.rows.length) {
                return;
            }

            this.activeExportInvoice.rows
                .filter(r => r.product_type === "product")
                .forEach(r => (this.sum += r.amount));
        }
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
